import React from 'react'
import Configurator from '../../../configurator'
import { i18n } from '../../../validator'
import Link from '../../../front/components/shared/sn-link'

@i18n()
export default class Actions extends Configurator {
    render() {
        const { t } = this.props

        return (
            <div className="Landing-actions" id="akce">
                <div className="Landing-actions-row">
                    <Link to="udalosti" className="Landing-actions-box">
                        <div className="Landing-actions-in">
                            <img src={`${this.config.REACT_APP_IMAGES_FOLDER}landing/event.jpg`} alt="" className="Landing-actions-in--photo" />
                            <div className="Landing-actions-in--text text-uppercase">
                                {t('events')}
                            </div>
                        </div>
                    </Link>
                    <Link to="kluby" className="Landing-actions-box">
                        <div className="Landing-actions-in">
                            <img src={`${this.config.REACT_APP_IMAGES_FOLDER}landing/team.jpg`} alt="" className="Landing-actions-in--photo" />
                            <div className="Landing-actions-in--text Landing-actions-in--text-dark">
                                <span className="Landing-actions-in--text-normal text-uppercase">
                                    {t('clubsAndGroups')}
                                </span>
                                <span className="Landing-actions-in--text-twoline text-uppercase">
                                    {t('clubsAndGroupsTwoLine')}
                                </span>
                            </div>
                        </div>
                    </Link>
                    <Link to="sportoviste" className="Landing-actions-box">
                        <div className="Landing-actions-in">
                            <img src={`${this.config.REACT_APP_IMAGES_FOLDER}landing/sport-venue.jpg`} alt="" className="Landing-actions-in--photo" />
                            <div className="Landing-actions-in--text text-uppercase">
                                {t('sportVenues')}
                            </div>
                        </div>
                    </Link>
                </div>
            </div>
        )
    }
}
